'use strict';
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { HGT } from '@/views/routes';
import './UserOptions.scss';
import { useAuth } from '@/hooks/auth.hook';
import { useAuth0 } from '@auth0/auth0-react';
import * as enums from '@/enums/Enums';
import { useLocalAuditLogger } from "@/hooks/useLocalAuditLogger";
import { usePermissions } from "@/hooks/permissions.hook";
import { Box } from '@mui/material';

export const UserOptions = (props) => {

	const [isAdmin, setIsAdmin] = useState(false);
	const logger = useLocalAuditLogger();
	const auth = useAuth();
	const { getAccessTokenSilently } = useAuth0();
	const history = useHistory();
	const { checkUserHasPermissions } = usePermissions();

	useEffect(() => {
		// Re-check permissions whenever checkUserHasPermissions changes (which happens when user data loads)
		let viewAdmin = checkUserHasPermissions("canViewAdmin");
		setIsAdmin(viewAdmin);
	}, [checkUserHasPermissions]);

	const adminClickHandler = useCallback(() => {
		history.push('/home/admin');
	}, [history]);

	const hgtClickHandler = useCallback(() => {
		history.push(`/home/${HGT}`);
	}, [history]);

	const signOutClickHandler = useCallback(async () => {
		// Get token for audit logging before logout
		const token = await getAccessTokenSilently({
			audience: 'https://portal-api'
		});
		logger.logOutUser(enums.AUDITLOG_USERACTION_TYPES.LOGOUT, token);
		// Redirect to landing page after logout (must match Auth0 whitelisted logout URLs)
		auth.logout('/');
		// Don't call history.push here - logout handles redirect via Auth0
	}, [auth, logger, getAccessTokenSilently]);


	return (
		<Box visibility={props.visible ? 'visible' : 'hidden'} className={"UserOptionsContainer"}>
			<div>{props.username}</div>
			<div>{props.email}</div>
			<hr />
			{isAdmin && <div className="hgt" onClick={hgtClickHandler}>HGT</div>}
			{isAdmin && <div className="admin" onClick={adminClickHandler}>Admin</div>}
			<hr />
			<div className="signout" onClick={signOutClickHandler}>Sign Out</div>
		</Box>
	);
};

export default UserOptions;